import type { TablePreview } from '@/bindings/TablePreview'
import { formatBytes, tableKey } from '@/features/cleanup/api'
import { useT } from '@/lib/i18n/translate'

/** A table's display name; one the page has no name for shows raw rather than nothing. */
export function TableName({ table }: { table: string }) {
  const t = useT()
  const key = tableKey(table)
  return <>{key ? t(key) : table}</>
}

/** Rows and approximate size per table, as the cleanup page (H7) and the restaurant delete (K4) show before acting. */
export function PreviewTable({ tables }: { tables: TablePreview[] }) {
  const t = useT()
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-muted text-left">
            <th className="py-1 pr-3 font-medium">{t('cleanup.col.table')}</th>
            <th className="py-1 pr-3 text-right font-medium">{t('cleanup.col.rows')}</th>
            <th className="py-1 text-right font-medium">{t('cleanup.col.bytes')}</th>
          </tr>
        </thead>
        <tbody>
          {tables.map((table) => (
            <tr key={table.table}>
              <td className="py-1 pr-3">
                <TableName table={table.table} />
              </td>
              <td className="py-1 pr-3 text-right tabular-nums">{table.rows.toLocaleString()}</td>
              <td className="py-1 text-right tabular-nums">{formatBytes(table.bytes)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
